import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Chip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Chip';
import classNames from 'classnames';
import Checkbox from 'Components/ComponentLibrary/Components/Uncategorized/Checkbox';
import { Paper } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import FundingTable from './FundingTable';

const useStyles = buildUseStyles('AccountItem', (theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
  },
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  paper: {
    width: '100%',
    padding: theme.spacing(2),
  },
  selected: {
    borderColor: theme.palette.primary.main,
  },
  completed: {
    borderColor: theme.palette.success.main,
  },
  chipContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  completedChip: {
    backgroundColor: theme.palette.success.main,
    color: 'white',
  },
  createdChip: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  },
  group: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  accountFunding: {
    marginLeft: theme.spacing(6),
    marginTop: theme.spacing(1.5),
  },
  fundingItems: {
    paddingTop: theme.spacing(1.5),
    paddingLeft: theme.spacing(6),
  },
  title: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(6),
  },
}));

const AccountItem = () => {
  const classes = useStyles();
  const { resource, handleChange } = useMetaLayoutContext();

  const canBeSelected = !resource.metaField('createOnActivation').attr('readonly');

  const getChip = () => {
    if (resource.isTruthy('isCompleted')) {
      return (<Chip size="medium" label={'Completed'} className={classes.completedChip} />);
    }
    if (resource.isTruthy('isCreated')) {
      return (<Chip size="medium" label={'Created'} className={classes.createdChip} />);
    }
    return null;
  };

  return (
    <div className={classNames(classes.root)}>
      <Typography className={classes.title} variant="h3">{'Account'}</Typography>
      <div className={classes.container}>
        {canBeSelected ? (
          <Checkbox
            value={resource.isTruthy('createOnActivation')}
            onClick={() => {
              handleChange('createOnActivation', (!resource.isTruthy('createOnActivation')).toString());
            }}
          />
        ) : null}

        <Paper
          className={classNames(classes.paper, {
            [classes.selected]: resource.isTruthy('createOnActivation') && canBeSelected,
            [classes.completed]: resource.isTruthy('isCompleted'),
          })}
          variant="outlined"
          rounded
        >
          <div className={classes.group}>
            <MetaField attr="title" />
            <MetaField attr="accountType" />
            <MetaField attr="accountModel" />
          </div>
          <div className={classes.group}>
            <MetaField attr="accountBalance" />
          </div>
          <MetaFormFields resource={resource} />
          <div className={classes.chipContainer}>
            {getChip()}
          </div>
        </Paper>
      </div>
      <div className={classes.fundingItems}>
        <FundingTable collection={resource?.attr('nextUpFundingItems')} readonly={!(resource.isTruthy('createOnActivation') && canBeSelected)} />
      </div>
    </div>
  );
};

export default AccountItem;
